export default __webpack_public_path__ + "static/media/murray.df863c7b.gif";